export default {"src":"/_next/static/media/loadingMochi.0d523a34.svg","height":18,"width":29,"blurWidth":0,"blurHeight":0};